import ObservableComponent from './ObservableComponent'

export default class Bubbles extends ObservableComponent {
  constructor (elem, APP) {
    super(elem, APP)
    this.bubbles = [...this.elem.querySelectorAll('.bubble')]
  }

  afterInView () {
    super.afterInView()
    this.bubbles.forEach((bubble, index) => {
      setTimeout(() => this.addClass('_is-revealed', bubble), 100 * index)
    })
  }

  init () {
    super.init()
  }
}
